import { Link } from "react-router-dom"
import NouvelleAnneeSteps from "./NouvelleAnneeSteps"
import { QueryRender } from "@/components/helpers/QueryRender"
import { useCurrentSchoolYear } from "@/entities/schoolYear/useSchoolYear"
import { format } from "date-fns"
import { fr } from "date-fns/locale"

export default function NouvelleAnneeIntroduction() {
   const currentSchoolYearQuery = useCurrentSchoolYear()

   return (
      <div className="container mx-auto p-4">
         <NouvelleAnneeSteps step={0} />

         <h1 className="text-2xl font-bold mb-6">Démarrer une nouvelle année</h1>

         <QueryRender query={currentSchoolYearQuery}>
            {(schoolYear) => (
               <div className="alert mb-8">
                  <div className="flex flex-col gap-2">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        className="stroke-info flex-shrink-0 w-6 h-6"
                     >
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           strokeWidth="2"
                           d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        ></path>
                     </svg>
                     <span>Année scolaire actuelle : {schoolYear.name}</span>
                     <span className="text-gray-500">
                        {format(schoolYear.start_date, "dd/MM/yyyy", { locale: fr })} -{" "}
                        {format(schoolYear.end_date, "dd/MM/yyyy", { locale: fr })}
                     </span>
                  </div>
                  <div className="flex flex-col gap-2">
                     {schoolYear.vacation_periods.map((period) => (
                        <div key={period.name}>
                           {period.name} : {format(period.start_date, "dd/MM/yyyy", { locale: fr })}{" "}
                           - {format(period.end_date, "dd/MM/yyyy", { locale: fr })}
                        </div>
                     ))}
                  </div>
               </div>
            )}
         </QueryRender>

         <div className="prose max-w-none mb-8">
            <p>
               Un administrateur doit, vers le 20 août, configurer l'application pour la nouvelle
               année scolaire.
               <strong>
                  Cette nouvelle année scolaire devient l'année de référence dans l'application
               </strong>
               .
            </p>
            <p>
               Etape 1 : paramétrer le planning scolaire avec les périodes de vacances de l'année
               scolaire à venir.
            </p>
            <p>Etape 2 : ré-assigner les jeunes dans les groupes.</p>
         </div>

         <Link to="/admin/nouvelle-annee/configurer-annee" className="btn btn-primary">
            Configurer la nouvelle année
         </Link>
      </div>
   )
}
